import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import * as Sentry from "@sentry/react"
import { trackWebVitals } from './lib/performance'

// Check environment
const isDevelopment = import.meta.env.MODE === 'development'

// Initialize Sentry with enhanced configuration
Sentry.init({
  dsn: "https://107af925fe1743f8afb3cf473e98e4fd@o4509104960372736.ingest.us.sentry.io/4509148087844864",
  integrations: [
    ...(isDevelopment ? [] : [
      // Only enable session replay in production
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
      }),
    ]),
    // Always enable browser tracing (lightweight)
    Sentry.browserTracingIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: isDevelopment ? 0.1 : 1.0,
  // Session Replay - disabled in development
  replaysSessionSampleRate: isDevelopment ? 0 : 0.1,
  replaysOnErrorSampleRate: isDevelopment ? 0 : 1.0,
  environment: import.meta.env.MODE,
  beforeSend(event) {
    // Add custom context
    if (event.user) {
      event.user.role = event.user.role || 'unknown'
    }
    return event
  }
})

// Track initial web vitals
trackWebVitals()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
